import React, { Component } from "react";
import { Grid, Card, Icon } from "@material-ui/core";
import { connect } from "react-redux";
import { compose } from "redux";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

class DealsSummary extends Component {
  render() {
    const { dealsSummary = {} } = this.props;

    const {
      closedWon       = 0,
      closedLost      = 0,
      openDeals       = 0,
      abandonedDeals  = 0,
      totalPipelineValue = 0,
      winRate         = 0,
    } = dealsSummary;

    // Format currency
    const formatCurrency = (val) => {
      if (val >= 1_000_000) return "$" + (val / 1_000_000).toFixed(1) + "M";
      if (val >= 1_000)     return "$" + (val / 1_000).toFixed(1) + "K";
      return "$" + val;
    };

    const donutOptions = {
      chart: {
        type: "pie",
        height: 260,
        backgroundColor: "transparent",
        margin: [0, 0, 0, 0],
        spacing: [0, 0, 0, 0],
      },
      title: { text: null },
      tooltip: {
        pointFormat: "<b>{point.name}</b>: {point.y} deals ({point.percentage:.1f}%)",
      },
      plotOptions: {
        pie: {
          innerSize: "62%",
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b><br>{point.percentage:.1f}%",
            style: { fontSize: "11px", fontWeight: "600", fontFamily: "'Inter', sans-serif" },
            distance: 14,
          },
          showInLegend: false,
        },
      },
      series: [
        {
          name: "Deals",
          colorByPoint: true,
          data: [
            { name: "Open",      y: openDeals,      color: "#42A5F5" },
            { name: "Won",       y: closedWon,       color: "#66BB6A" },
            { name: "Lost",      y: closedLost,      color: "#EF5350" },
            { name: "Abandoned", y: abandonedDeals,  color: "#FFA726" },
          ],
        },
      ],
      credits: { enabled: false },
    };

    const statItems = [
      { label: "Open Deals",       value: openDeals,                 icon: "trending_up",     color: "#1565C0", bg: "rgba(21,101,192,0.08)"  },
      { label: "Closed Won",       value: closedWon,                 icon: "check_circle",    color: "#2E7D32", bg: "rgba(46,125,50,0.08)"   },
      { label: "Closed Lost",      value: closedLost,                icon: "cancel",          color: "#C62828", bg: "rgba(198,40,40,0.08)"   },
      { label: "Abandoned",        value: abandonedDeals,            icon: "block",           color: "#E65100", bg: "rgba(230,81,0,0.08)"    },
      { label: "Pipeline Value",   value: formatCurrency(totalPipelineValue), icon: "account_balance_wallet", color: "#4527A0", bg: "rgba(69,39,160,0.08)" },
      { label: "Win Rate",         value: winRate + "%",             icon: "emoji_events",    color: "#00695C", bg: "rgba(0,105,92,0.08)"    },
    ];

    const cardStyle = {
      background: "linear-gradient(135deg, rgba(255,255,255,0.97), rgba(240,248,255,0.85))",
      borderRadius: "20px",
      border: "1px solid rgba(255,255,255,0.6)",
      boxShadow: "0 10px 40px -10px rgba(31,38,135,0.1)",
      overflow: "hidden",
      marginBottom: "28px",
    };

    const headerStyle = {
      padding: "20px 28px 16px",
      background: "linear-gradient(90deg, rgba(102,187,106,0.08), rgba(3,169,244,0.05))",
      borderBottom: "1px solid rgba(0,0,0,0.04)",
    };

    const titleStyle = {
      margin: 0,
      fontSize: "1.2rem",
      fontWeight: 700,
      color: "#2E7D32",
      fontFamily: "'Inter', sans-serif",
      letterSpacing: "-0.01em",
    };

    return (
      <Card elevation={0} style={cardStyle}>
        <div style={headerStyle}>
          <h3 style={titleStyle}>Deals Summary</h3>
        </div>
        <div style={{ padding: "20px 24px" }}>
          <Grid container spacing={3} alignItems="center">
            {/* Donut Chart */}
            <Grid item xs={12} md={5}>
              <HighchartsReact highcharts={Highcharts} options={donutOptions} />
            </Grid>

            {/* Stats Cards */}
            <Grid item xs={12} md={7}>
              <Grid container spacing={2}>
                {statItems.map((item) => (
                  <Grid item xs={6} key={item.label}>
                    <div
                      style={{
                        background: item.bg,
                        borderRadius: "14px",
                        padding: "14px 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        border: `1px solid ${item.color}22`,
                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                        cursor: "default",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = `0 6px 16px ${item.color}22`;
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = "none";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      <div
                        style={{
                          width: "38px",
                          height: "38px",
                          borderRadius: "10px",
                          background: item.color,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          boxShadow: `0 3px 8px ${item.color}44`,
                        }}
                      >
                        <Icon style={{ color: "#fff", fontSize: "1.2rem" }}>{item.icon}</Icon>
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: "1.4rem",
                            fontWeight: 700,
                            color: item.color,
                            lineHeight: 1.1,
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          {item.value}
                        </div>
                        <div style={{ fontSize: "0.75rem", fontWeight: 600, color: "#607d8b", marginTop: "3px" }}>
                          {item.label}
                        </div>
                      </div>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({ apolloClient: state.apolloClient });
const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(DealsSummary);
